<template>
  <div class="left">
    <el-scrollbar class="page-component__scroll">
      <el-menu
        :default-active="$route.path"
        class="left_menu_list"
        @open="handleOpen"
        @close="handleClose"
        background-color="#20222A"
        text-color="#fff"
        active-text-color="#ffd04b"
        :collapse="isCollapse"
      >
        <el-menu-item v-if="!checkChildren()" :index="'/'+menu.path">
          <i class="el-icon-menu"></i>
          <span slot="title" class="link_span"><router-link :to="{path:'/'+menu.path}">{{menu.name}}</router-link></span>
        </el-menu-item>
        <el-submenu v-for="(item, index) in menu.children" :key="index" :index="index.toString()" v-else>
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <el-menu-item v-for="(citem, cindex) in item.children" :key="cindex" :index="'/'+citem.path">
            <span slot="title" class="link_span"><router-link :to="{path:'/'+citem.path}">{{citem.name}}</router-link></span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "left",
  props: {
    menu: Object
  },
  data() {
    return {
      isCollapse: false
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    checkChildren() {
      if (this.menu.children == undefined || this.menu.children.length == 0) {
        return false;
      }
      return true;
    }
  },
  watch: {
    menu(value) {
      console.log(value);
    }
  }
};
</script>

<style scoped>
.left {
  width: 220px;
  position: fixed;
  top: 40px;
  bottom: 0;
  background-color: #20222a !important;
}
.left_menu_list .link_span a{ color: #ffffff;}
.left_menu_list a.router-link-active{ color: #ffd04b;}
</style>